/* eslint-disable react-hooks/rules-of-hooks */
import { useState, useEffect } from "react";
import { Select, Button, Form, Row, Col, DatePicker, Alert } from "antd";
import locale from "antd/es/date-picker/locale/es_ES";
import "dayjs/locale/es";
import dayjs from "dayjs";
import calendar from "dayjs/plugin/calendar";

import { formatDate, removeDuplicates } from "../../utils/utils";
import { useSearchParams } from "react-router-dom";
import { useFetchOrdersBy, useFilters } from "../../app/orders/mutations";
import useFetchMaster from "../../app/maestro/mutations";
dayjs.extend(calendar);

const { RangePicker } = DatePicker;

export function HeaderForm({
  onSubmit,
  disabled,
  ordersIds,
  documentsIds,
  statuses,
  isLoading,
}) {
  const [form] = Form.useForm();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isDisabled, setIsDisabled] = useState(disabled);
  const [clientQuery, setClientQuery] = useState([]);
  const [_statuses, setStatuses] = useState(statuses);

  const [points, setPoints] = useState([]);

  const queryParams = Object.fromEntries([...searchParams]);
  let { isLoading: isLoadingMaster, data: master } = useFetchMaster();

  const { addFilter } = useFilters();

  useEffect(() => {
    setIsDisabled(disabled);
    setStatuses(statuses);
  }, [disabled, statuses]);

  const onFinish = (values) => {
    const { fechaInicioPedido: f1 } = values;

    if (f1 && f1.length === 2) {
      const [start, end] = f1;
      if (end.diff(start, 'months', true) > 1) {
        form.setFields([{
          name: 'fechaInicioPedido',
          errors: ['El rango de fechas no puede ser mayor a un mes'],
        }]);
        return;
      }
    }
  
    const queryDates = {
      fechaInicioPedido: formatDate(f1[0].$d),
      fechaFinPedido: formatDate(f1[1].$d),
      Cliente: clientQuery,
    };

    setSearchParams(queryDates);
    onSubmit(queryDates);
    

    form.setFieldValue("cedula", null);
    form.setFieldValue("fechaFinPromesa", null);
    form.setFieldValue("fechaInicioPromesa", null);
  };

  const handleClientNameChange = (client) => {
    const clientsIds = client.map((c) => c.split("-")[0]);

    if (clientsIds.length > 1 && clientsIds.includes("TODOS")) {
      form.setFieldValue(
        "nombreCliente",
        client.filter((c) => c !== "TODOS")
      );
      setClientQuery(clientsIds.filter((c) => c !== "TODOS").join(","));
    } else {
      setClientQuery(clientsIds.join(","));

      if (clientsIds.includes("TODOS")) {
        setPoints(master.clientes);
      } else {
        const clients = clientsIds.filter((c) => c !== "TODOS");
        const points = master.clientes.filter((c) =>
          clients.includes(c.id_cliente)
        );
        setPoints(points);
      }
    }
  };

  const handlePointChange = (event) => {
    addFilter({
      label: "Punto de venta",
      prop: "puntoVenta",
      value: event.split("-")[1],
    });
    useFetchOrdersBy();
    form.setFieldValue("puntoVenta", null);
  };

  const handleDocumentChange = (event) => {
    const searchTerm = event;
    if (searchTerm) {
      addFilter({
        label: "Cedula",
        prop: "cedula",
        value: searchTerm,
      });
      useFetchOrdersBy();
    }
    form.setFieldValue("cedula", null);
  };

  const handleOrderChange = (event) => {
    const searchTerm = event;
    if (searchTerm && searchTerm.length > 0) {
      addFilter({ label: "Orden", prop: "codigoPedido", value: searchTerm });
      useFetchOrdersBy();
    }
    form.setFieldValue("ordenCompra", null);
  };

  const handleStatusChange = (event) => {
    addFilter({ label: "Estado", prop: "estado", value: event });
    useFetchOrdersBy();
    form.setFieldValue("estado", null);
  };

  const handleClear = () => {
    form.setFieldValue("nombreCliente", undefined);
  };

/*Control 30 dias en seleccion de fecha*/
  const [range, setRange] = useState([null, null]);

  const handleRangeChange = (dates) => {
    if (!dates || dates.length === 0) {
      setRange([null, null]);
      form.setFieldsValue({ fechaInicioPedido: null });
    } else {
      const [start, end] = dates;
      if (start && end && end.diff(start, 'days') > 30) {
        const newEnd = start.clone().add(30, 'days');
        setRange([start, newEnd]);
        form.setFieldsValue({ fechaInicioPedido: [start, newEnd] });
      } else {
        setRange(dates);
        form.setFieldsValue({ fechaInicioPedido: dates });
      }
    }
  };

  const disabledDate = (current) => {
    if (!range[0] && !range[1]) {
      return false;
    }
    const tooLate = range[0] && current > dayjs(range[0]).add(30, 'day');
    const tooEarly = range[1] && current < dayjs(range[1]).subtract(30, 'day');
    return tooLate || tooEarly;
  };
/*Control 30 dias en seleccion de fecha*/

  return (
    <div className="orders-form">
      {(!isLoadingMaster && (master?.clientes && master?.clientes.length <= 0)) && (<Alert
        message="No existen clientes asociados a su cuenta."
        type="error"
        showIcon
      />)}
      {!isLoadingMaster && master.clientes && master?.clientes.length > 0 && (
        <Form
          form={form}
          autoComplete="off"
          name="ordersForm"
          layout="vertical"
          onFinish={onFinish}
          initialValues={{
            fechaInicioPedido: [dayjs(
              queryParams.fechaInicioPedido || dayjs().subtract(2, "day"),
              "YYYY-MM-DD"
            ),dayjs(
              queryParams.fechaFinPedido || dayjs().add(2, "day"),
              "YYYY-MM-DD"
            ),]
          }}
        >
          <Row>
            <Col className="gutter-row">
            <Form.Item
              name="fechaInicioPedido"
              label="Fecha Pedido"
              rules={[{ required: true, message: "Requerido" }]}
            >
              <RangePicker
                locale={locale}
                size="medium"
                onCalendarChange={handleRangeChange}
                disabledDate={disabledDate}
                value={form.getFieldValue('fechaInicioPedido')}
              />
            </Form.Item>
            </Col>
            <Col className="gutter-row clientSelect">
              {!isLoadingMaster && master && (
                <Form.Item
                  name="nombreCliente"
                  rules={[
                    { required: true, message: "El cliente es requerido*" },
                  ]}
                  label="Cliente"
                >
                  <Select
                    showSearch
                    mode="multiple"
                    size="medium"
                    placeholder="Seleccione"
                    allowClear={true}
                    onClear={handleClear}
                    options={[
                      {
                        value: "TODOS",
                        label: "TODOS",
                      },
                      ...removeDuplicates(
                        master?.clientes.map(
                          (e) => `${e.id_cliente}-${e.nombre_cliente}`
                        )
                      ).map((p, index) => {
                        return {
                          value: `${p}`,
                          label: `${p.toUpperCase().split("-")[1]}`,
                        };
                      }),
                    ]}
                    onChange={handleClientNameChange}
                  />
                </Form.Item>
              )}
            </Col>
            <Col className="gutter-row">
              <Form.Item>
                <Button
                  htmlType="submit"
                  type="default"
                  className="btn-green"
                  id="btn-order"
                  size="medium"
                  loading={isLoading}
                  disabled={isLoading}
                >
                  Consultar
                </Button>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col className="gutter-row">
              <Form.Item
                name="ordenCompra"
                rules={[{ required: false, message: "requerido" }]}
                label="Pedido / Orden"
              >
                <Select
                  showSearch
                  size="medium"
                  placeholder="Seleccione"
                  disabled={isDisabled}
                  onClear={handleClear}
                  options={ordersIds.map((document) => {
                    return {
                      value: document,
                      label: document,
                    };
                  })}
                  onChange={handleOrderChange}
                />
              </Form.Item>
            </Col>
            <Col className="gutter-row">
              <Form.Item
                name="cedula"
                rules={[{ required: false, message: "requerido" }]}
                label="Cedula"
              >
                <Select
                  showSearch
                  size="medium"
                  placeholder="Seleccione"
                  disabled={isDisabled}
                  onClear={handleClear}
                  options={documentsIds.map((document) => {
                    return {
                      value: document,
                      label: document,
                    };
                  })}
                  onChange={handleDocumentChange}
                />
              </Form.Item>
            </Col>
            <Col className="gutter-row">
              {!isLoadingMaster && master && (
                <Form.Item
                  name="puntoVenta"
                  rules={[{ required: false, message: "requerido" }]}
                  label="Punto de Venta"
                >
                  <Select
                    showSearch
                    size="medium"
                    placeholder="Seleccione"
                    disabled={isDisabled}
                    filterSort={(optionA, optionB) =>
                      (optionA?.label ?? "")
                        .toLowerCase()
                        .localeCompare((optionB?.label ?? "").toLowerCase())
                    }
                    options={[
                      ...points.map((p) => {
                        return {
                          value: `${p.punto_venta}-${p.nombre_punto_venta}`,
                          label: `${p.punto_venta}-${p.nombre_punto_venta}`,
                        };
                      }),
                    ]}
                    onChange={handlePointChange}
                  />
                </Form.Item>
              )}
            </Col>
            <Col className="gutter-row">
              <Form.Item
                name="estado"
                rules={[{ required: false, message: "requerido" }]}
                label="Estado"
              >
                <Select
                  showSearch
                  size="medium"
                  placeholder="Seleccione"
                  disabled={isDisabled}
                  onClear={handleClear}
                  options={_statuses}
                  onChange={handleStatusChange}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      )}
    </div>
  );
}
